export const domain = 'App';

export const OPEN_CANCEL_CONFIRM_MODAL = `${domain}/OPEN_CANCEL_CONFIRM_MODAL`;
export const OPEN_EXIT_CONFIRM_MODAL = `${domain}/OPEN_EXIT_CONFIRM_MODAL`;
export const CLOSE_CANCEL_CONFIRM_MODAL = `${domain}/CLOSE_CANCEL_CONFIRM_MODAL`;
export const CLOSE_EXIT_CONFIRM_MODAL = `${domain}/CLOSE_EXIT_CONFIRM_MODAL`;
export const SET_SALESPERSON_ID = `${domain}/SET_SALESPERSON_ID`;
export const DESTROY_SALESPERSON_ID = `${domain}/DESTROY_SALESPERSON_ID`;
export const SET_APPLICATION_FORM_DATA = `${domain}/SET_APPLICATION_FORM_DATA`;
export const DESTROY_APPLICATION_FORM_DATA = `${domain}/DESTROY_APPLICATION_FORM_DATA`;
